import { Component, ElementRef, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ActionEventsEnum } from '@toro/common/shared/enum/tracking/action-events.enum';
import { DialogPanelComponentContent } from '@toro/common/shared/models/dialogs/DialogPanelComponentContent';
import { TrackingsService } from '../../../../../services/tracking.service';

@Component({
  selector: 'hub-workspace-no-profile-panel',
  templateUrl: './no-profile-panel.component.html',
  styleUrls: ['./no-profile-panel.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class NoProfilePanelComponent extends DialogPanelComponentContent implements OnInit {

  constructor(
    protected element: ElementRef,
    private dialogReference: MatDialogRef<NoProfilePanelComponent>,
    private router: Router,
    private tracking: TrackingsService,
  ) { super(element, true); }

  ngOnInit(): void {
    super.ngOnInit();
    let step: String = this.returnStepMetric();
    this.tracking.sendMetricsToMixpanel(ActionEventsEnum.MODAL_OPENED, {
      'Product Area Origin': 'Bolsa',
      'Step': step,
      'Status': 'Sem perfil definido',
      'Text': 'Defina seu Perfil de Investidor para começar a investir',
      'Time Responsável': 'Roebling',
    });
  }

  public navigateToSuitability() {
    let step: String = this.returnStepMetric();
    this.tracking.sendMetricsToMixpanel(ActionEventsEnum.ELEMENT_CLICKED, {
      'Product Area Origin': 'Bolsa',
      'Element': 'Botão atualizar perfil de investidor',
      'Group': 'Modal',
      'Step': step,
      'Status': 'Sem perfil definido',
      'Time Responsável': 'Roebling',
    });

    this.dialogReference.close();
    this.router.navigate(['/novo-suitability/questionario']);
  }

  private returnStepMetric(): String {
    const currentUrl: String = this.router.url;

    if (currentUrl.includes('explore-o-mercado')) {
      return 'Explore o mercado';
    } else if (currentUrl.includes('analise')) {
      return 'Análise do ativo';
    }
  }

  public dispose(event: Event) {
    super.close(this.dialogReference, null);
    event.preventDefault();
  }
}
